import styled from "styled-components";

import { DESKTOP_BREAKPOINT } from "../../../../components/AppShell/styles";

const MOBILE = `not all and (min-width: ${DESKTOP_BREAKPOINT})`;

export const Container = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  padding: 1rem;
  cursor: pointer;
  background-color: var(--color-neutral-dark);
  border: 1px solid transparent;
  border-radius: 1rem;
  transition: border-color 0.15s;

  &:hover {
    border-color: var(--color-neutral-base);
  }

  @media (min-width: ${DESKTOP_BREAKPOINT}) {
    gap: 1.25rem;
    padding: 1rem 1.25rem 1rem 1rem;
  }
`;

export const Info = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0;

  .url {
    overflow: hidden;
    font-size: 0.75rem;
    line-height: 1rem;
    color: var(--color-neutral-150);
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const TitleRow = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  min-width: 0;

  /* Always a single line: long titles end with an ellipsis, the PLUS tag stays beside them */
  h4 {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const Status = styled.span<{ $active: boolean }>`
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  margin-top: 0.25rem;
  font-family: Inter, sans-serif;
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1rem;
  color: ${props => (props.$active ? "var(--color-feedback-success)" : "var(--color-neutral-150)")};

  &::before {
    width: 6px;
    height: 6px;
    content: "";
    background-color: currentColor;
    border-radius: 100%;
  }
`;

export const Actions = styled.div`
  display: flex;
  flex-shrink: 0;
  gap: 0.75rem;
  align-items: center;

  .chevron {
    display: flex;
    color: var(--color-neutral-150);
  }

  /* the agenda's shortcut is a button: the round look of the others, without the browser's own */
  button.agenda {
    padding: 0;
    border: 0;
  }

  /* Opening the Keepo in a new tab is a desktop-only shortcut */
  @media ${MOBILE} {
    .launch {
      display: none;
    }
  }
`;
